import { render, staticRenderFns } from "./invoiceHistory.vue?vue&type=template&id=1cbc8e9a&scoped=true&"
import script from "./invoiceHistory.vue?vue&type=script&lang=js&"
export * from "./invoiceHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cbc8e9a",
  null
  
)

export default component.exports